export const LanguageTypes = {
  en: 'en',
  da: 'da',
};
export const LanguageHeader = {
  en: 'en-US',
  da: 'da-DK',
};
export const LanguageCodes = {
  [LanguageTypes.en]: 'English',
  [LanguageTypes.da]: 'Dansk',
};
export const LANGUAGE = 'LANGUAGE';
export const TEMPORARY = 'TEMPORARY';
// masked MFA destination (e.g. "***5678") from the login `pending.mfa` body —
// persisted so the SMS page survives a refresh (batch 001; dest is no longer a
// token claim as it was in legacy).
export const MFA_DEST_MASKED = 'MFA_DEST_MASKED';
// LDOC (TOS/PP) step: pending legal docs (JSON [{type,versionId,label,updated,
// publishedAt}]) from login `pending.legal`, persisted so /tos-and-pp survives a
// refresh (batch 003).
export const LDOC_PENDING = 'LDOC_PENDING';
// Which login flow the pending LDOC step belongs to: 'password' | 'sso' (batch 004,
// ADR-9). /tos-and-pp needs it to pick between POST /v1/login/legal/accept and
// POST /v1/sso/legal/accept, because the real discriminator is the tmp ticket's
// AUDIENCE (aud=ldoc vs aud=ldoc.sso) and audience is not readable from the payload.
// Picking wrong is a 401, never a token the caller should not have — the audience
// mismatch is fail-closed on the server side.
export const LDOC_FLOW = 'LDOC_FLOW';
// MFA resend cooldown (PD-2932). Epoch ms of the moment the last verification
// code was DISPATCHED — written wherever a code actually goes out (login-step's
// `pending.next === STEP_MFA` branch for the first code, login-sms's resend for
// every later one), never when the SMS page mounts. Storing the absolute instant
// rather than a counter is what makes the cooldown survive an F5: the page
// derives the real remaining seconds instead of restarting the 60.
//
// The KEY STRING stays the legacy `LAST_COUNTDOWN_TIMESTAMP` on purpose.
// Renaming it would strand the values already sitting in users' browsers with
// nothing left that ever reads — or clears — them; keeping it means the first
// read finds them expired and purges them (mfa-countdown.ts).
export const MFA_COUNTDOWN_STARTED_AT = 'LAST_COUNTDOWN_TIMESTAMP';
export const ACCESS = 'ACCESS';

// ⚠️ DISPLAY formats. `DATE_FORMAT_DAYJS` is what a Danish clinician reads on
// screen; it is NOT how a date arrives from or leaves for the backend.
export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_FORMAT_DAYJS = 'DD.MM.YYYY';
export const DATE_SLASH_FORMAT_DAYJS = 'DD/MM/YYYY';

// The WIRE format for every plain date the patient contract carries
// (`birth_date`, `admission_date` — both declared `string`, "YYYY-MM-DD", parsed
// and formatted in UTC only, never timezone-converted).
//
// It exists as its own constant because the display constant above was the only
// date format in this file, and reaching for it to parse a wire value is a
// silent, total failure rather than a wrong-looking one: `customParseFormat` is
// extended across the patient form tree, so parsing "1985-07-07" as
// "DD.MM.YYYY" yields an Invalid Date, and react-datepicker throws
// `RangeError: Invalid time value` while rendering it — a blank page, not a
// blank field. Found in the assembled-system gate on the edit page.
export const DATE_FORMAT_WIRE_DAYJS = 'YYYY-MM-DD';

export const PASSWORD_REGEX_CAPITAL = /[A-Z]/;
export const PASSWORD_REGEX_LOWER = /[a-z]/;
export const PASSWORD_REGEX_SYMBOL = /[\\`~!@#$%^&*()_+\-= ,.\/<>?\[\]{}|;':"]/;
export const PASSWORD_REGEX_NUMBER = /[0-9]/;
export const PASSWORD_REGEX_LENGTH = /^.{12,65}$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\`~!@#$%^&*()_+\-= ,.\/<>?\[\]{}|;':"])[0-9a-zA-Z\\`~!@#$%^&*()_+\-= ,.\/<>?\[\]{}|;':"]{12,65}$/;
export const PASSWORD_SINGLE_CHAR =
  /^[0-9a-zA-Z\\`~!@#$%^&*()_+\-= ,.\/<>?\[\]{}|;':"]$/;

// ⚠️ DELETED with PD-2956: `ADMISSION_DATE_METADATA_KEY` and
// `TREATMENT_INDICATION_METADATA_KEY`. They were the literal Danish keys the
// legacy `department_metadata` rows were stored under, used only to look the
// admission date and treatment indication up inside a row's `metadatas` — the
// EAV shape ADR-A14 dropped as never delivered. Both values are plain columns
// now (`admission_date` / `admission_reason`).
//
// One of the two SAME literals does still exist, once, as `ADMISSION_DATE_LABEL`
// in components/patient-form/metadata/metadata.tsx — and it is the date
// control's name there, rendered verbatim as its label, not a lookup key. The
// reason's literal is gone: since PD-3021 item 2 that control is identified by
// the language-independent `ADMISSION_REASON_FIELD` and labelled through the
// i18n key `cdb_pinned_patient_treatment_indication_text`. Do not
// "de-duplicate" these back together with the deleted keys; they had different
// jobs and only one of the jobs still exists.

export const REDIRECT_SEARCH_PARAM_KEY = 'redirect';

export const PATIENT_LIST_POLLING_INTERVAL = 60000;
